<div class="row">
    <div class="col-md-12 col-sm-12 table-responsive no-border">
     <form [formGroup]="deviceForm" novalidate>
        <table class="table table-condensed">
            <tbody>
                <tr>
                    <td class="col-sm-12 no-right-padding no-left-padding">
                        <table formArrayName="packageForm" class="table table-inner table-condensed">
                            <tbody>
                                <tr>
                                    <th>Package DI</th>
                                    <th>Package DI Issuing Agency</th>
                                    <th>Contains Package DI</th>
                                    <th>Contains Package DI Issuing Agency</th>
                                    <th>Package Quantity</th>
                                    <th>Package Type</th>
                                    <th>Package Status</th>
                                    <th>Package Discontinued Date </th>
                                </tr>
                                <ng-container *ngIf="packageForm.controls.length; else emptyTemplate8fields">
                                <tr formGroupName="{{i}}" *ngFor="let item of packageForm.controls; let i = index">
                                    <td [ngClass]="isDefault('Packages')"><label controlName="packageDi"></label></td>
                                    <td [ngClass]="isDefault('Packages')"><label
                                            controlName="packageAgency"></label></td>
                                    <td [ngClass]="isDefault('Packages')"><label
                                            controlName="containingDI"></label></td>
                                    <td [ngClass]="isDefault('Packages')"><label
                                            controlName="containingAgency"></label></td>
                                    <td [ngClass]="isDefault('Packages')"><label controlName="packageQty"></label>
                                    </td>
                                    <td [ngClass]="isDefault('Packages')"><label controlName="packageType"></label>
                                    </td>
                                    <td [ngClass]="isDefault('Packages')"><label controlName="packageStatusValue"></label>
                                    </td>
                                    <td [ngClass]="isDefault('Packages')"><label controlName="packageDiscontinuedDate"></label>
                                    </td>
                                </tr>
                              </ng-container>
                            </tbody>
                        </table>

                    </td>
                </tr>


            </tbody>
        </table>
    </form>
    </div>
</div>

<ng-template #emptyTemplate8fields>
  <tr>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
    <td><label class="label-padding-bottom-10"></label></td>
  </tr>
</ng-template>
